import { HttpHeaders, HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BasicResponse } from "@auth-suite-services/services";
import { Observable, catchError, throwError } from "rxjs";
import { TemplateInterfaceAPI, TemplateInterface } from "../model/template";
import { mbeConfigService } from "./mbe-config.service";


@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllTemplates(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<TemplateInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<TemplateInterfaceAPI>(`${this.URL}/tem/getalltemplates/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers}).pipe(catchError(this.handleError));
  }

  getTemplate(id: number): Observable<TemplateInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<TemplateInterface>(`${this.URL}/tem/gettemplate/${id}`, {headers}).pipe(catchError(this.handleError));
  }

  updateTEM(tem: TemplateInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tem: ' + JSON.stringify(tem));
    return this.httpClient.post<BasicResponse>(`${this.URL}/tem/updatetemplate`, tem, {headers}).pipe(catchError(this.handleError));
  }

  createTEM(tem: TemplateInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Create tem: ' + JSON.stringify(tem));
    return this.httpClient.post<BasicResponse>(`${this.URL}/tem/createtemplate`, tem, {headers}).pipe(catchError(this.handleError));
  }

  //added call to set status                                            16/11/23 CN
  setTemplateStatus(id: {id: number}): Observable<BasicResponse> {
    console.log("======================================================================");
    console.log(id.id);
    console.log("======================================================================");
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/tem/settemplatestatus/${id.id}`, {headers}).pipe(catchError(this.handleError));
  }

  // Dashboard image Format=3 template. 21/10/2026 DW
  getTemplateNoticeBoard(): Observable<TemplateInterface> {
    const headers = this.headers;
    return this.httpClient
      .get<TemplateInterface>(`${this.URL}/tem/gettemplatenoticeboard`, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  updateTEMNoticeBoard(tem: TemplateInterface): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient
      .post<BasicResponse>(
        `${this.URL}/tem/createupdatetemplatenoticeboard`,
        tem,
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}
